import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {tap} from 'rxjs';
import {SnackBarActions} from '@aviary/store/snack-bar/snack-bar.actions';
import {SnackBarService} from './snack-bar.service';

// eslint-disable-next-line @angular-eslint/use-injectable-provided-in -- This is registered via NgRx; it's not an Angular tree-shakable provider.
@Injectable()
export class SnackBarEffects {

  private readonly actions: Actions = inject(Actions);
  private readonly snackBarService: SnackBarService = inject(SnackBarService);

  public show = createEffect(
    () => this.actions.pipe(
      ofType(SnackBarActions.show),
      tap(({message, action}) => this.snackBarService.show(message, action))
    ),
    {dispatch: false}
  );

  public showSuccess = createEffect(
    () => this.actions.pipe(
      ofType(SnackBarActions.showSuccess),
      tap(({message, action}) => this.snackBarService.showSuccess(message, action))
    ),
    {dispatch: false}
  );

  public showError = createEffect(
    () => this.actions.pipe(
      ofType(SnackBarActions.showError),
      tap(({message, action}) => this.snackBarService.showError(message, action))
    ),
    {dispatch: false}
  );

  public showCenteredMultilineSuccess = createEffect(
    () => this.actions.pipe(
      ofType(SnackBarActions.showCenteredMultilineSuccess),
      tap(({lines}) => this.snackBarService.showCenteredMultilineSuccess(lines))
    ),
    {dispatch: false}
  );

  public showCenteredMultilineError = createEffect(
    () => this.actions.pipe(
      ofType(SnackBarActions.showCenteredMultilineError),
      tap(({lines}) => this.snackBarService.showCenteredMultilineError(lines))
    ),
    {dispatch: false}
  );

  public showWithRouterLink = createEffect(
    () => this.actions.pipe(
      ofType(SnackBarActions.showWithRouterLink),
      tap(({config}) => this.snackBarService.showWithRouterLink(config))
    ),
    {dispatch: false}
  );

  public showSuccessWithRouterLink = createEffect(
    () => this.actions.pipe(
      ofType(SnackBarActions.showSuccessWithRouterLink),
      tap(({config}) => this.snackBarService.showSuccessWithRouterLink(config))
    ),
    {dispatch: false}
  );

  public showErrorWithRouterLink = createEffect(
    () => this.actions.pipe(
      ofType(SnackBarActions.showErrorWithRouterLink),
      tap(({config}) => this.snackBarService.showErrorWithRouterLink(config))
    ),
    {dispatch: false}
  );

  public hide = createEffect(
    () => this.actions.pipe(
      ofType(SnackBarActions.hide),
      tap(() => this.snackBarService.hide())
    ),
    {dispatch: false}
  );
}
